module.exports = __webpack_public_path__ + "static/media/illustration-gps-2.de1d45ef.svg";